import { createRouter } from "@tanstack/react-router";
import { appRoutes } from "./app/routes";
import { labRoutes } from "./lab/routes";
import { rootRoute } from "./root-route";

// Les routes de l'app sont declarees dans src/app/routes.tsx, qui appartient a l'app.
// Celles du template (pages legales, « Mes donnees ») viennent de src/lab/routes.tsx :
// toutes les apps du Lab les servent, aux memes adresses.
export const routeTree = rootRoute.addChildren([...appRoutes, ...labRoutes]);

export const router = createRouter({ routeTree, defaultPreload: "intent" });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
